import { useState, useEffect, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";
import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import { useNavigate,useLocation } from "react-router";
import { useSelector } from 'react-redux';

const ComponentEdit = () => {
  const toast = useRef(null);
  const location = useLocation();
  const currencyreducer = useSelector((state)=>state.currencyreducer);
  const [supllierlist,setSupllierlist] = useState([]);
  const [currencies,setCurrencies] = useState([]);
   const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    component: "",
    componentSkuCode: "",
    componentType: "",
    description: "",
    supplier: "",
    cost: "",
    stockLevel: "",
    freightCharges: "",
    unitOfMeasurement: "",
    superdrugSkuCode: "",
    supplier_cost:"",
    supplier_currency:"",
    notes: "",
  });

    const inputRefs = {
      component: useRef(null),
      componentSkuCode: useRef(null),
      componentType: useRef(null),
      supplier: useRef(null),
      cost: useRef(null),
      stockLevel: useRef(null),
      freightCharges: useRef(null),
      unitOfMeasurement: useRef(null),
      superdrugSkuCode: useRef(null),
      supplier_cost:useRef(null),
  };

  const validateForm = () => {
  const newErrors = {};

  // if (!formData.component.trim()) {
  //   newErrors.component = "Component is required";
  // }

  // if (!formData.componentSkuCode.trim()) {
  //   newErrors.componentSkuCode = "Component SkuCode is required";
  // }

  // if (!formData.componentType.trim()) {
  //   newErrors.componentType = "Component Type is required";
  // }

  // if (!formData.supplier.trim()) {
  //   newErrors.supplier = "Supplier is required";
  // }

  // if (!formData.cost.trim()) {
  //   newErrors.cost = "Cost is required";
  // }

  // if (!String(formData.stockLevel).trim()) {
  //   newErrors.stockLevel = "Stock Level is required";
  // }

  // if (!formData.freightCharges.trim()) {
  //   newErrors.freightCharges = "Freight Charges is required";
  // }

  // if (!formData.unitOfMeasurement.trim()) {
  //   newErrors.unitOfMeasurement = "UnitOfMeasurement is required";
  // }
  // if (!formData.superdrugSkuCode.trim()) {
  //   newErrors.superdrugSkuCode = "SuperdrugSkuCode is required";
  // }

  //   if (!String(formData.supplier_cost).trim()) {
  //   newErrors.supplier_cost = "Supplier cost is required";
  // }

  
  // // Add other validations here...

  // setErrors(newErrors);
  // // Focus first error field
  // const firstErrorKey = Object.keys(newErrors)[0];
  // if (firstErrorKey && inputRefs[firstErrorKey]) {
  //   inputRefs[firstErrorKey].current.focus();
  // }
  // return Object.keys(newErrors).length === 0;
};

  useEffect(()=>{
    setFormData(location.state?.supplier);
    getsupplier();
    getcurrency();
  },[])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlesubmit = (e) => {
    e.preventDefault();
    // if (validateForm()) {
    productservices.editcomponent(formData).then((response)=>{
        console.log(response);
         if(response.status == 200){
            //  console.log€0
            toast.current.show({ severity: 'success', summary: 'Component', detail: 'Component created successfully' }); 
         }else{
            toast.current.show({ severity: 'error', summary: 'Component', detail: `${response.data.data}` }); 
         }   
    }).catch((error)=>{
        toast.current.show({ severity: 'error', summary: 'Component', detail: 'Error' }); 
    });
  // }


    // Handle form submission here
  };

  const handleClose = () => {
    // Handle close action here
  };
  const getsupplier = () =>{
      supplierservices.getbulkdata().then((response)=>{
        console.warn(response);
           setSupllierlist(response.data.data);
        }).catch((error)=>{
            
        });
    }

  function displaySupplier2(){
    let supllierdata = [];
    supllierlist.forEach((value,index)=>{
      supllierdata.push(<option value={value.id}>{value.name}</option>); 
    });

    return supllierdata;
  }


  const getcurrency = () => {
    currencyreducer.then((response)=>{
      
      // console.log("currency reducer");
      // console.log(response);
        setCurrencies(response);
      }).catch((error)=>{
    });
   } 

   const displayCurrency = () => {
    let items = [];
    currencies.forEach((value,index)=>{
       items.push(<option key={index} value={value.code}>{value.code}</option>);
    })  
    return items;
  }

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Product/addproduct"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        <Titlebar text={"Edit Component"} />
        <div className="col-md-12 mt-3">
          <div className="card ps-5 pe-5">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4"></div>
                <form onSubmit={(e) => handlesubmit(e)}>
                  <div className="row">
                    {/* Component Name */}
                    <div className="col-md-6 form-group">
                      <label>Component</label>
                      <input
                        type="text"
                        name="component"
                        className={`form-control ${errors.component ? "is-invalid" : ""}`}
                        placeholder="Enter Component Name"
                        value={formData.component}
                        onChange={handleChange}
                        ref={inputRefs.component}
                      />
                      {errors.component && <div className="invalid-feedback">{errors.component}</div>}
                    </div>

                    {/* Component SKU Code */}
                    <div className="col-md-6 form-group">
                      <label>Component SKU Code</label>
                      <input
                        type="text"
                        name="componentSkuCode"
                        className={`form-control ${errors.componentSkuCode ? "is-invalid" : ""}`}
                        placeholder="Enter Component SKU Code"
                        value={formData.componentSkuCode}
                        onChange={handleChange}
                        ref={inputRefs.componentSkuCode}
                      />
                       {errors.componentSkuCode && <div className="invalid-feedback">{errors.componentSkuCode}</div>}
                    </div>

                    {/* Component Type */}
                    <div className="col-md-6 form-group">
                      <label>Component Type</label>
                      <select
                        name="componentType"
                        className={`form-control ${errors.componentType ? "is-invalid" : ""}`}
                        value={formData.componentType}
                        onChange={handleChange}
                         ref={inputRefs.componentType}
                      >
                        <option value="">Select Component Type</option>
                        <option value="normal">Normal</option>
                        <option value="freeissue">Free issue Ingredient</option>
                      </select>
                      {errors.componentType && <div className="invalid-feedback">{errors.componentType}</div>}
                    </div>

                    {/* Description */}
                    <div className="col-md-6 form-group">
                      <label>Description</label>
                      <input
                        type="text"
                        name="description"
                        className="form-control"
                        placeholder="Enter Description (e.g., Bottle, Label)"
                        value={formData.description}
                        onChange={handleChange}
                      />
                      
                    </div>

                    {/* Supplier */}
                    <div className="col-md-6 form-group">
                      <label>Supplier</label>
                      <select
                        name="supplier"
                        className={`form-control ${errors.supplier ? "is-invalid" : ""}`}
                        value={formData.supplier}
                        onChange={handleChange}
                        ref={inputRefs.supplier}
                      >
                        <option value="">Select Supplier</option>
                         {displaySupplier2()}
                      </select>
                       {errors.supplier && <div className="invalid-feedback">{errors.supplier}</div>}
                      {/* <input
                        type="text"
                        name="supplier"
                        className="form-control"
                        placeholder="Enter Supplier"
                        value={formData.supplier}
                        onChange={handleChange}
                      /> */}
                    </div>

                    {/* Cost */}
                    <div className="col-md-6 form-group">
                      <label>Cost</label>
                      <div className="flex-box">
                            <select className="form-control" name="cost_currency" style={{width:'60px'}} onChange={handleChange} value={formData.cost_currency}>
                               {displayCurrency()}
                            </select>
                            <input
                              type="text"
                              name="cost"
                              className={`form-control ${errors.cost ? "is-invalid" : ""}`}
                              placeholder="Enter Cost"
                              value={formData.cost}
                              onChange={handleChange}
                              ref={inputRefs.cost}
                            />
                      </div>
                    {errors.cost && <div className="invalid-feedback">{errors.cost}</div>}

                    </div>

                    {/* Stock Level */}
                    <div className="col-md-6 form-group">
                      <label>Stock Level</label>
                      <input
                        type="text"
                        name="stockLevel"
                        className={`form-control ${errors.stockLevel ? "is-invalid" : ""}`}
                        placeholder="Enter Stock Level"
                        value={formData.stockLevel}
                        onChange={handleChange}
                        ref={inputRefs.stockLevel}
                      />
                      {errors.stockLevel && <div className="invalid-feedback">{errors.stockLevel}</div>}
                    </div>

                    {/* Freight Charges */}
                    <div className="col-md-6 form-group">
                      <label>Freight Charges</label>
                      <input
                        type="text"
                        name="freightCharges"
                        className={`form-control ${errors.freightCharges ? "is-invalid" : ""}`}
                        placeholder="Enter Freight Charges"
                        value={formData.freightCharges}
                        onChange={handleChange}
                        ref={inputRefs.freightCharges}
                      />
                       {errors.freightCharges && <div className="invalid-feedback">{errors.freightCharges}</div>}
                    </div>

                    {/* Unit of Measurement */}
                    <div className="col-md-6 form-group">
                      <label>Unit of Measurement</label>
                      <select
                        name="unitOfMeasurement"
                        className={`form-control ${errors.unitOfMeasurement ? "is-invalid" : ""}`}
                        value={formData.unitOfMeasurement}
                        onChange={handleChange}
                        ref={inputRefs.unitOfMeasurement}
                      >
                        <option value="">Select Unit of Measurement</option>
                        <option value="ml">ml</option>
                        <option value="kg">kg</option>
                        <option value="unit">Unit</option>
                      </select>
                {errors.unitOfMeasurement && <div className="invalid-feedback">{errors.unitOfMeasurement}</div>}

                    </div>

                    {/* Superdrug SKU Code */}
                    <div className="col-md-6 form-group">
                      <label>Superdrug SKU Code</label>
                      <input
                        type="text"
                        name="superdrugSkuCode"
                        className={`form-control ${errors.superdrugSkuCode ? "is-invalid" : ""}`}
                        placeholder="Enter Superdrug SKU Code"
                        value={formData.superdrugSkuCode}
                        onChange={handleChange}
                        ref={inputRefs.superdrugSkuCode}
                      />
                {errors.superdrugSkuCode && <div className="invalid-feedback">{errors.superdrugSkuCode}</div>}

                    </div>

                    {/* Notes (Full Width) */}
                    <div className="col-md-12 form-group">
                      <label>Notes</label>
                      <textarea
                        name="notes"
                        className="form-control"
                        placeholder="Enter Note"
                        value={formData.notes}
                        onChange={handleChange}
                      ></textarea>
                    </div>

                    
                    <div className="col-md-6 form-group">
                      <label>Supplier Cost</label>
                          <div className="flex-box">
                             <select className="form-control" name="supplier_currency" style={{width:'60px'}} onChange={handleChange} value={formData.supplier_currency}>
                               {displayCurrency()}
                            </select>
                            <input
                              type="text"
                              name="supplier_cost"
                              className={`form-control ${errors.supplier_cost ? "is-invalid" : ""}`}
                              placeholder="Enter Supplier Cost"
                              value={formData.supplier_cost}
                              onChange={handleChange}
                              ref={inputRefs.supplier_cost}
                            />
                      </div>
                    {errors.supplier_cost && <div className="invalid-feedback">{errors.supplier_cost}</div>}

                    </div>
                  </div>

                  <br></br>
                  <br></br>
                  <div className="row">
                    <div className="col-md-6">
                      <button
                        type="submit"
                        className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                        // onClick={handleSave}
                      >
                        Save
                      </button>
                    </div>

                    <div className="col-md-6">
                      <button
                        type="button"
                        className="btn color-white w-100 rounded custom-btn-color-secondary"
                        onClick={handleClose}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComponentEdit;
